import { Signal } from '@preact/signals';

export const resumedListener = (videoPlaying: Signal<boolean>) => {
  videoPlaying.value = true;
};
